// Public list prices, in the smallest currency unit. Pricing.tsx shows these
// until the live Stripe prices load -- and since scripts/prerender.js blocks
// every third-party request, they are also exactly what the prerendered
// /pricing HTML (what crawlers read) carries. public/index.html's
// SoftwareApplication offers repeat them; src/listPricing.test.ts keeps all
// three in step with scripts/setupStripePricing.sh.
export const LIST_PRICING = {
  monthly: {
    unitAmount: 24900,
    currency: "usd",
  },
  yearly: {
    unitAmount: 249000,
    currency: "usd",
  },
};

// "$249/month"-style English copy for public marketing pages, which (unlike
// Pricing.tsx) don't wait on live Stripe prices.
export const LIST_PRICE_LABELS = {
  monthly: formatListPrice(LIST_PRICING.monthly, "month"),
  yearly: formatListPrice(LIST_PRICING.yearly, "year"),
};

function formatListPrice({ unitAmount, currency }: { unitAmount: number; currency: string }, interval: string) {
  return `${new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    maximumFractionDigits: 0,
  }).format(unitAmount / 100)}/${interval}`;
}
